import { ICellRendererParams } from "ag-grid-enterprise";
import React from "react";

import { IgChip, IgTypography } from "@intelligems/ig-theme";
import { officialStatusName } from "@intelligems/ig-utils";
import { Grid, Skeleton, styled, useTheme } from "@mui/material";
import { GenericCenteredContainer } from "@src/components/MainApp/SharedProductPicker/list/containers";
import {
  ProductPickerProduct,
  ProductStatus,
} from "@src/store/slices/productPicker/types";

export const ProductListStatus = ({
  data,
}: ICellRendererParams<ProductPickerProduct>) => {
  const theme = useTheme();
  const SkeletonColors = {
    Archived: theme.palette.text.interactive.neutral.disabled, // exception to the icon fill rules, used in experiment table only
    Active: theme.igIconColors.success,
    Draft: theme.igIconColors.warning,
  };

  if (!data?.status) return null;

  const status = getStatus(data.status);
  return (
    <IgChip
      color={status.type}
      sx={{
        border: "none",
        backgroundColor: "transparent",
      }}
      label={
        <Grid
          container
          columnSpacing={2}
          alignItems={"center"}
          flexWrap={"nowrap"}
        >
          <Grid item>
            <Skeleton
              animation={false}
              variant={"circular"}
              sx={{
                width: "8px",
                height: "8px",
                backgroundColor: SkeletonColors[status?.label],
              }}
            />
          </Grid>
          <Grid item>
            <IgTypography
              variant={"body2"}
              color={theme.palette.text.secondary}
            >
              {status?.label}
            </IgTypography>
          </Grid>
        </Grid>
      }
    />
  );
};

function getStatus(status: ProductStatus) {
  switch (status) {
    case ProductStatus.Active:
      return {
        type: "success",
        label: "Active",
      } as const;
    case ProductStatus.Draft:
      return {
        type: "info",
        label: "Draft",
      } as const;
    case ProductStatus.Archived:
      return {
        type: "default",
        label: "Archived",
      } as const;
  }
}
